/** Shared API base URL for user website (local dev vs production). */
const PRODUCTION_API_BASE = 'https://rehman-travels-api.onrender.com/api';
const LOCAL_API_BASE = 'http://localhost:5000/api';

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'development' ? LOCAL_API_BASE : PRODUCTION_API_BASE);

/** Origin without `/api` suffix — for static files served by the API host. */
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/i, '');
